<div class="wrapper-page wrapper-my-list">
<!--  <tl-header></tl-header>-->
  <div class="wrapper-header-my-lists">
    <div class="header-my-lists">
      <span>{{'TERMS_AND_CONDITION.text1' | translate}}</span>
    </div>
  </div>
  <div class="wrapper-content-my-lists favorite-lists">
    <div class="content-my-lists">
      <div class="content-privacy-policy">
        <span class="title-text">{{'TERMS_AND_CONDITION.text2' | translate}}</span>
        <p>{{'TERMS_AND_CONDITION.text3' | translate}}<a href="https://the.lysts.com"> https://the.lysts.com</a>{{'TERMS_AND_CONDITION.text4' | translate}}</p>
        <p>{{'TERMS_AND_CONDITION.text5' | translate}}</p>
        <p>{{'TERMS_AND_CONDITION.text6' | translate}}</p>
        <p>{{'TERMS_AND_CONDITION.text7' | translate}}</p>
        <p>{{'TERMS_AND_CONDITION.text8' | translate}}</p>
        <h5>{{'TERMS_AND_CONDITION.text9' | translate}}</h5>
        <p>{{'TERMS_AND_CONDITION.text10' | translate}}</p>
        <ul>
          <li>{{'TERMS_AND_CONDITION.text11' | translate}}</li>
          <li>{{'TERMS_AND_CONDITION.text12' | translate}}</li>
          <li>{{'TERMS_AND_CONDITION.text13' | translate}}</li>
          <li>{{'TERMS_AND_CONDITION.text14' | translate}}</li>
          <li>{{'TERMS_AND_CONDITION.text15' | translate}}</li>
          <li>{{'TERMS_AND_CONDITION.text16' | translate}}</li>
          <li>{{'TERMS_AND_CONDITION.text17' | translate}}</li>
          <li>{{'TERMS_AND_CONDITION.text18' | translate}}</li>
          <li>{{'TERMS_AND_CONDITION.text19' | translate}}</li>
        </ul>
        <h5>{{'TERMS_AND_CONDITION.text21' | translate}}</h5>
        <p>{{'TERMS_AND_CONDITION.text22' | translate}}</p>
        <p>{{'TERMS_AND_CONDITION.text23' | translate}}</p>
        <h5>{{'TERMS_AND_CONDITION.text24' | translate}}</h5>
        <p>{{'TERMS_AND_CONDITION.text25' | translate}}</p>
        <p>{{'TERMS_AND_CONDITION.text26' | translate}}</p>
        <p>{{'TERMS_AND_CONDITION.text27' | translate}}</p>
        <p>{{'TERMS_AND_CONDITION.text28' | translate}}</p>
        <h5>{{'TERMS_AND_CONDITION.text29' | translate}}</h5>
        <p>{{'TERMS_AND_CONDITION.text30' | translate}}</p>
        <h5>{{'TERMS_AND_CONDITION.text31' | translate}}</h5>
        <p>{{'TERMS_AND_CONDITION.text32' | translate}}</p>
        <p>{{'TERMS_AND_CONDITION.text33' | translate}}</p>
        <p>{{'TERMS_AND_CONDITION.text34' | translate}}</p>
        <p>{{'TERMS_AND_CONDITION.text35' | translate}}</p>
        <h5>{{'TERMS_AND_CONDITION.text36' | translate}}</h5>
        <p>{{'TERMS_AND_CONDITION.text37' | translate}}</p>
        <h5>{{'TERMS_AND_CONDITION.text38' | translate}}</h5>
        <p>{{'TERMS_AND_CONDITION.text39' | translate}}</p>
        <h5>{{'TERMS_AND_CONDITION.text40' | translate}}</h5>
        <p>{{'TERMS_AND_CONDITION.text41' | translate}}</p>
        <p>{{'TERMS_AND_CONDITION.text42' | translate}}</p>
        <p>{{'TERMS_AND_CONDITION.text43' | translate}}</p>
        <p>{{'TERMS_AND_CONDITION.text44' | translate}}</p>
        <p>{{'TERMS_AND_CONDITION.text45' | translate}}</p>
        <p>{{'TERMS_AND_CONDITION.text46' | translate}}</p>
        <p>{{'TERMS_AND_CONDITION.text47' | translate}}</p>
        <p>{{'TERMS_AND_CONDITION.text48' | translate}}</p>
        <h5>{{'TERMS_AND_CONDITION.text49' | translate}}</h5>
        <p>{{'TERMS_AND_CONDITION.text50' | translate}}</p>
        <h5>{{'TERMS_AND_CONDITION.text51' | translate}}</h5>
        <p>{{'TERMS_AND_CONDITION.text52' | translate}}</p>
        <h5>{{'TERMS_AND_CONDITION.text53' | translate}}</h5>
        <p>{{'TERMS_AND_CONDITION.text54' | translate}}</p>
      </div>
    </div>
  </div>
</div>
